/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

//TODO rename to iriroDisableAutocomplete
@Directive({
  selector: '[disableAutocomplete], [iriro-disableAutocomplete]',
})
export class DisableAutocompleteDirective implements AfterViewInit {
  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'readonly', '');
    this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'off');
    this.renderer.setAttribute(
      this.el.nativeElement,
      'onfocus',
      "this.removeAttribute('readonly');"
    );
  }
}
